// src/utils/constants.js

export const LEAD_STATUSES = ['New', 'Follow-up', 'In Conversation', 'Customer', 'Not Interested'];

export const LEAD_SOURCES = ['Facebook Ads', 'Whatsapp Ads', 'Insta Ads', 'Referral', 'Website', 'Walk-in', 'Other'];

export const ROLES = ['Admin', 'Manager', 'Agent'];

export const TASK_STATUSES = ['Pending', 'In Progress', 'Completed'];

export const ORDER_STATUSES = ['Pending', 'Booked', 'In Transit', 'Delivered', 'Cancelled'];
